import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {filter, map, take} from 'rxjs';
import {AuthenticationStateEnum} from '../enums/AuthenticationStateEnum';
import {UserSessionService} from '../services/user-session.service';

export const hasTwoFactorAuthEnabledGuard: CanActivateFn = () => {
  const userSessionService = inject(UserSessionService);
  const router = inject(Router);

  return userSessionService.authState$.pipe(
    filter(state => state !== undefined),
    take(1),
    map(state => {
      if (state !== AuthenticationStateEnum.LOGGED_IN_TWO_FACTOR_AUTHENTICATION_NOT_ENABLED) {
        return true;
      }

      router.navigate(['auth', 'two-factor', 'enable']).then();
      return false;
    }),
  );
};
